import React, { FC, useEffect, useState } from 'react'
import classes from './OutSourcingDialog.module.scss'
import {
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  useTheme,
} from '@mui/material'
import { Buttons } from '../../uikit/atoms/buttons/Buttons'
//PDFアイコン
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
//ダウンロードアイコン
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt'
//csvアイコン
import DatasetIcon from '@mui/icons-material/Dataset'
import { WithIconButton } from '../../uikit/atoms/buttons/WithIconButton'
import { useGetWorkerInfo } from '../../../hooks/api/workers/useGetWorkerInfo'
import MonthPicker from '../../uikit/atoms/datepickers/MonthPicker'

import { RecoilState, useRecoilState } from 'recoil'
import { fromToDateState } from '../../../states/dateState'
import { useGetDiraryListWithDateRange } from '../../../hooks/api/posts/useGetDiraryListWithDateRange'
import {
  formatEndOfMonth,
  formatMonth,
  formatStartOfMonth,
} from '../../../utils/functions/formatting'
import {
  calculateSummaryTotals,
  createSummaryForOutsourcing,
  summaryForOutsourcing,
  summaryTotals,
} from '../../../utils/functions/summaryForOutsorcing'
import { Dirary } from '../../../types/dirary'
import { useGetSupplierInfo } from '../../../hooks/api/suppliers/useGetgetSupplierInfo copy'
import { useCreateNotePdf } from '../../../hooks/api/suppliers/useCreateNotePdf'
import CircularProgress from '@mui/material/CircularProgress'
import useCsvExporter from '../../../hooks/util/useCsvDownloarderForOutsourcing'
import { styled } from '@mui/system'
import { useMobile } from '../../../hooks/token/useMobile'
import EmailIcon from '@mui/icons-material/Email'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import MailDialog from './mail/MailDialog'
import { User } from '../../../types'
import { userState } from '../../../states/userState'
import { setUserToLocalStorage } from '../../../utils/functions/localStorageManager'
import SelectBoxForNumber from '../../uikit/atoms/selectboxes/SelectBoxForNumber'
import { factoriesForInput } from '../../../utils/variables/factoriesForInupt'
import { useGetAddressList } from '../../../hooks/api/address/useGetAddress'
type ButtonCheckParams = {
  workerId: string
  workerName: string
  supplierId: string
  supplierName: string
  loadingAnimation: boolean
}
function checkButtonActivate({
  workerId,
  workerName,
  supplierId,
  supplierName,
  loadingAnimation,
}: ButtonCheckParams) {
  console.log(
    'debbug',
    'workerId',
    workerId,
    'workerName',
    workerName,
    'supplierId',
    supplierId,
    'supplierName',
    supplierName,
    'loadingAnimation',
    loadingAnimation
  )
  if (loadingAnimation) return false
  if (workerId.length > 0 && workerName.length > 0) {
    if (supplierId.length === 0 && supplierName.length === 0) return true
    if (supplierId.length > 0 && supplierName.length > 0) return true
    if (supplierId.length > 0 && supplierName.length === 0) return false
  } else {
    return false
  }
}
const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiTypography-root': {
    fontSize: '14px', // フォントサイズを変更
    color: theme.palette.text.secondary, // デフォルトカラー
    transition: 'color 0.3s', // なめらかな色変化
  },
  '& .Mui-checked + .MuiTypography-root': {
    color: theme.palette.primary.main, // チェック状態のカラー
  },
  '&:hover .MuiTypography-root': {
    color: theme.palette.primary.light, // ホバー時のカラー
  },
}))
type Props = {
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>
  workerId: string
  productNo: string
  productBno: string
}
const getEndOfMonth = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}
const OutSourcingDialog: FC<Props> = (props) => {
  const [pdfData, setPdfData] = useState<ArrayBuffer | null>(null)
  const [dateState, setDateState] = useRecoilState(fromToDateState)
  const [isShowMailDialog, setShowMailDialog] = useState(false)
  const [diaryList, setDiaryList] = useState<Dirary[]>([])
  const [summaryForOutsourcing, setSummaryForOutsourcing] = useState<
    summaryForOutsourcing[][]
  >([])
  const [summaryTotals, setSummaryTotals] = useState<summaryTotals[]>([])
  const [fromDate, setFromdate] = useState<Date>(dateState.from), //日付From
    [toDate, setTodate] = useState<Date>(getEndOfMonth(dateState.from)) //日付To
  const { setIsShow, workerId, productNo, productBno } = props
  const [open, setOpen] = useState(true)
  const theme = useTheme()
  const getWorkerInfo = useGetWorkerInfo()
  const getSupplierInfo = useGetSupplierInfo()
  const [disabledOutSource, setDisabledOutSource] = useState(true)
  const [disabledWorkDetail, setDisabledWorkDetail] = useState(true)
  const { getDiaryListByWokerAndDaysWithHoliday } =
    useGetDiraryListWithDateRange()
  const { getNotePdf, loadingAnimation } = useCreateNotePdf()
  const { exportCsv } = useCsvExporter()
  const [pdfUrl, setPdfUrl] = useState<string | null>(null) // PDF URL用の状態
  const [filterOption, setFilterOption] = useState<'all' | 'single'>('single') // ラジオボタンの状態管理;
  const { isMobile } = useMobile()
  const [user, setUser] = useRecoilState<User>(userState)
  const { getToAddressList, getCcAddressList } = useGetAddressList()

  const [toEmail, setToEmail] = useState('')
  const [ccEmail, setCcEmail] = useState('')
  const [factoryId, setFactoryId] = useState(
    user.initialParameters.factoryNoForOutsourcingCc === 0
      ? 50
      : user.initialParameters.factoryNoForOutsourcingCc
  )
  //エラーメッセージ-2
  const [errorWorkerName, setErrorWorkerName] = useState({
    isShow: true,
    text: '未設定',
  })
  const [workerInfo, setWorkerInfo] = useState({
    workerId: workerId,
    workerName: '',
    departmentId: null,
    departmentName: null,
    place: null,
  })
  const [errorSupplierName, setErrorSupplierName] = useState({
    isShow: true,
    text: '未設定',
  })
  const [supplierInfo, setSupplierInfo] = useState({
    supplierId: '',
    supplierName: '',
    supplierShortName: '',
  })
  const handleCancelButtonClick = () => {
    setOpen(false)
    setIsShow(false)
  }
  //社員番号入力
  const handleChangeWorkerId = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= 5) {
      setWorkerInfo((prevState) => ({
        ...prevState,
        workerId: e.target.value,
      }))
      if (e.target.value.length === 0) {
        setErrorWorkerName({ isShow: true, text: '未設定' })
      } else {
        setErrorWorkerName({ isShow: false, text: '' })
      }
      // setErrorWorkerName({ isShow: true, text: "未設定" });
    }
  }
  const handleFocusWorkerId = () => {
    // console.log("Field is focused");
    setWorkerInfo((prevState) => ({
      ...prevState,
      workerId: '',
      workerName: '',
      departmentId: null,
      departmentName: null,
      place: null,
    }))
    setErrorWorkerName({ isShow: true, text: '未設定' })
    setDiaryList([])
    setSummaryForOutsourcing([])
  }
  const onSearch = async (mode: string = 'full') => {
    // console.log("Field has lost focus");
    if (workerInfo.workerId.length > 0) {
      const res = await getWorkerInfo(workerInfo.workerId)
      // console.log(res);
      if (res) {
        setWorkerInfo((prevState) => ({
          ...prevState,
          workerId: res[5],
          workerName: res[0],
          departmentId: res[1],
          departmentName: res[6],
          place: res[3],
        }))
        setErrorWorkerName({
          isShow: false,
          text: ``,
        })
        const startMonth = formatStartOfMonth(fromDate)
        const endMonth = formatEndOfMonth(fromDate)
        console.log('ProductNo', productNo, productBno)
        const response = await getDiaryListByWokerAndDaysWithHoliday(
          res[5],
          startMonth,
          endMonth,
          filterOption === 'single' ? productNo : '',
          filterOption === 'single' ? productBno : ''
        )
        setDiaryList(response)
        const summary = createSummaryForOutsourcing(
          response,
          startMonth,
          endMonth,
          supplierInfo.supplierId,
          supplierInfo.supplierShortName
        )
        setSummaryForOutsourcing(summary)
        if (mode === 'full') {
          const data = await getToAddressList(res[5], '')
          if (!data?.length) {
            setToEmail('')
          } else {
            setToEmail(data[0].address)
          }
        }
      } else {
        setWorkerInfo((prevState) => ({
          ...prevState,
          workerName: '',
          departmentId: null,
          departmentName: null,
          place: null,
        }))
        setErrorWorkerName({ isShow: true, text: '見つかりません' })
        setDiaryList([])
        setSummaryForOutsourcing([])
        if (mode === 'full') {
          setToEmail('')
        }
      }
    }
  }

  //仕入先番号入力
  const handleChangeSupplierId = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= 5) {
      setSupplierInfo((prevState) => ({
        ...prevState,
        supplierId: e.target.value,
      }))
      if (e.target.value.length === 0) {
        setErrorSupplierName({ isShow: true, text: '未設定' })
      } else {
        setErrorSupplierName({ isShow: false, text: '' })
      }
      // setErrorWorkerName({ isShow: true, text: "未設定" });
    }
  }
  const handleFocusSupplierId = () => {
    // console.log("Field is focused");
    setSupplierInfo((prevState) => ({
      ...prevState,
      supplierId: '',
      supplierName: '',
      supplierShortName: '',
    }))
    const startMonth = formatStartOfMonth(fromDate)
    const endMonth = formatEndOfMonth(fromDate)
    const summary = createSummaryForOutsourcing(
      diaryList,
      startMonth,
      endMonth,
      '',
      ''
    )
    setSummaryForOutsourcing(summary)
    setErrorSupplierName({ isShow: true, text: '未設定' })
  }
  const onSearchSupplier = async () => {
    // console.log("Field has lost focus");
    if (supplierInfo.supplierId.length > 0) {
      const res = await getSupplierInfo(supplierInfo.supplierId)
      // console.log(res);
      if (res) {
        setSupplierInfo((prevState) => ({
          ...prevState,
          supplierId: res[2],
          supplierName: res[0],
          supplierShortName: res[1],
        }))
        setErrorSupplierName({
          isShow: false,
          text: ``,
        })
        const startMonth = formatStartOfMonth(fromDate)
        const endMonth = formatEndOfMonth(fromDate)
        const summary = createSummaryForOutsourcing(
          diaryList,
          startMonth,
          endMonth,
          res[2],
          res[1]
        )
        setSummaryForOutsourcing(summary)
      } else {
        setSupplierInfo((prevState) => ({
          ...prevState,
          supplierName: '',
          supplierShortName: '',
        }))
        const startMonth = formatStartOfMonth(fromDate)
        const endMonth = formatEndOfMonth(fromDate)
        const summary = createSummaryForOutsourcing(
          diaryList,
          startMonth,
          endMonth,
          '',
          ''
        )
        setSummaryForOutsourcing(summary)
        setErrorSupplierName({ isShow: true, text: '見つかりません' })
      }
    }
  }

  useEffect(() => {
    if (
      checkButtonActivate({
        workerId: workerInfo.workerId,
        workerName: workerInfo.workerName,
        supplierId: supplierInfo.supplierId,
        supplierName: supplierInfo.supplierName,
        loadingAnimation,
      })
    ) {
      setDisabledOutSource(false)
      setDisabledWorkDetail(false)
    } else {
      setDisabledOutSource(true)
      setDisabledWorkDetail(true)
    }
  }, [workerInfo, supplierInfo, loadingAnimation])

  const downloadCsv = () => {
    const filename =
      filterOption === 'single'
        ? `作業明細_${
            workerInfo.workerName
          }_${productNo}-${productBno}_${formatMonth(fromDate)}`
        : `作業明細_${workerInfo.workerName}_${formatMonth(fromDate)}`
    exportCsv(summaryForOutsourcing, filename)
  }
  const createPdf = async () => {
    const data = await getNotePdf(summaryForOutsourcing, summaryTotals)
    // PDFデータを受け取りBlobからオブジェクトURLを作成
    const blob = new Blob([data], { type: 'application/pdf' })
    const pdfUrl = URL.createObjectURL(blob)
    // 新しいタブでPDFを表示
    setPdfUrl(pdfUrl) // URLを状態に設定
    const arrayBuffer = await blob.arrayBuffer()
    setPdfData(arrayBuffer) // 新しい状態としてArrayBufferを保持
    window.open(pdfUrl, '_blank')
  }

  useEffect(() => {
    if (workerId.length > 0) {
      onSearch('full')
    }
  }, [workerId])
  useEffect(() => {
    setSummaryTotals(calculateSummaryTotals(summaryForOutsourcing))
  }, [summaryForOutsourcing])

  useEffect(() => {
    onSearch('exceptToEmail')
  }, [fromDate, toDate, filterOption])
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterOption(event.target.value as 'all' | 'single')
  }
  //工場番号入力
  const handleFactoryChange = (e: number) => {
    setFactoryId(e)
    // setDiaryList((prevState) =>
    //   prevState.map((diary) => {
    //     if (diary.id === id) {
    //       return { ...diary, factoryId: e };
    //     }
    //     return diary;
    //   })
    // );

    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          factoryNoForOutsourcingCc: e,
        },
      }
      setUserToLocalStorage(newUser)
      return newUser
    })
  }
  useEffect(() => {
    const fetchCcAddressList = async () => {
      const res = await getCcAddressList('', String(factoryId))
      if (!res?.length) {
        setCcEmail('')
        return
      } else {
        const newCcEmail = res
          .filter((address: any) => address.isSelected)
          .map((address: any) => address.address)
          .join(',')
        setCcEmail(newCcEmail)
      }
    }
    fetchCcAddressList()
  }, [factoryId])
  useEffect(() => {
    console.log('diary_list', diaryList)
  }, [diaryList])
  return (
    <Modal
      open={open}
      onClose={handleCancelButtonClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: theme.palette.foreColor.main,
        border: 'none',
        '&:focus-visible': {
          borderColor: theme.palette.foreColor.main,
          outlineColor: theme.palette.foreColor.main, // Assuming your theme's primary.main is the color you want
        },
      }}
    >
      <div className={classes.formContainer}>
        <div className={classes.inputArea}>
          <div className={classes.firstContents}>
            <div className={classes.datePickers}>
              <MonthPicker
                setFromdate={setFromdate}
                setTodate={setTodate}
                fromDate={fromDate}
                toDate={toDate}
              />
            </div>
            {/* {!isMobile && (
              <div className={classes.mailButton}>
                <WithIconButton
                  disabled={!pdfUrl || loadingAnimation} // PDF生成中はボタンを無効化
                  onClick={() => setShowMailDialog(true)}
                  width={120}
                  height={36}
                  fontSize={16}
                  icon={<EmailIcon />}
                  label={"メール送信"}
                />
              </div>
            )} */}
            {!isMobile && (
              <div className={classes.mailContainer}>
                <div className={classes.factoryArea}>
                  <p>CC</p>
                  <SelectBoxForNumber
                    label={''}
                    options={factoriesForInput}
                    required={true}
                    select={handleFactoryChange}
                    value={factoryId}
                    disabled={false}
                    width={'85px'}
                    height={'38px'}
                    fontSize={'12px'}
                    colorMode={'dark'}
                    setMode={'input'}
                  />
                </div>
                <div className={classes.mailButton}>
                  <WithIconButton
                    disabled={!pdfUrl || loadingAnimation} // PDF生成中はボタンを無効化
                    onClick={() => setShowMailDialog(true)}
                    width={120}
                    height={36}
                    fontSize={16}
                    icon={<EmailIcon />}
                    label={'メール送信'}
                  />
                </div>
              </div>
            )}
          </div>
          <div className={classes.secondContents}>
            <div className={classes.worker}>
              <div className={classes.workerId}></div>
              <TextField
                helperText={errorWorkerName.text}
                error={errorWorkerName.isShow}
                label="社員番号"
                variant="standard"
                type="number"
                multiline={false}
                value={workerInfo.workerId}
                sx={{
                  height: '70px',
                  width: '100px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  //スピンボタンの無効化-効いていない
                  ':global(input[type="number"]::-webkit-outer-spin-button)': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                  ':global(input[type="number"]::-webkit-inner-spin-button)': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },

                  '& .MuiInputBase-input': {
                    color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                    fontSize: '16px',
                    // その他のスタイル設定...
                  },
                  '& label': {
                    color: theme.palette.foreColor.main, // 通常時のラベル色
                    //backgroundColor:"white"
                  },
                  '& label.Mui-focused': {
                    color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
                  },
                  '& .MuiInput-underline:before': {
                    borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
                  },
                  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                    },
                    '&:hover fieldset': {
                      borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                    },
                    '& .MuiInputBase-root': {},
                  },
                }}
                onChange={handleChangeWorkerId}
                onFocus={handleFocusWorkerId}
                onBlur={() => onSearch('full')}
                placeholder="1234or01234"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <div className={classes.workerInfo}>
                <p>{workerInfo.departmentName}</p>
                <p>{workerInfo.workerName}</p>
              </div>
            </div>
            <div className={classes.worker}>
              <div className={classes.workerId}></div>
              <TextField
                helperText={errorSupplierName.text}
                error={errorSupplierName.isShow}
                label="仕入先番号"
                variant="standard"
                type="number"
                multiline={false}
                value={supplierInfo.supplierId}
                sx={{
                  height: '70px',
                  width: '100px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  //スピンボタンの無効化-効いていない
                  ':global(input[type="number"]::-webkit-outer-spin-button)': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                  ':global(input[type="number"]::-webkit-inner-spin-button)': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },

                  '& .MuiInputBase-input': {
                    color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                    fontSize: '16px',
                    // その他のスタイル設定...
                  },
                  '& label': {
                    color: theme.palette.foreColor.main, // 通常時のラベル色
                    //backgroundColor:"white"
                  },
                  '& label.Mui-focused': {
                    color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
                  },
                  '& .MuiInput-underline:before': {
                    borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
                  },
                  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                    },
                    '&:hover fieldset': {
                      borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                    },
                    '& .MuiInputBase-root': {},
                  },
                }}
                onChange={handleChangeSupplierId}
                onFocus={handleFocusSupplierId}
                onBlur={onSearchSupplier}
                placeholder="1234or01234"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <div className={classes.workerInfo}>
                <p>{supplierInfo.supplierShortName}</p>
                <p>{supplierInfo.supplierName}</p>
              </div>
            </div>
            <div className={classes.radioGroup}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="filter"
                  name="filter"
                  value={filterOption}
                  onChange={handleRadioChange}
                  // disabled={loadingAnimation} // ローディング中に無効化
                >
                  <CustomFormControlLabel
                    value="all"
                    control={<Radio disabled={loadingAnimation} />} // ローディング中にボタン無効化
                    label="全件"
                  />
                  <CustomFormControlLabel
                    value="single"
                    control={<Radio disabled={loadingAnimation} />} // ローディング中にボタン無効化
                    label="この製番のみ"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
        <div className={classes.hr}></div>
        <div className={classes.buttons}>
          <div>
            <WithIconButton
              disabled={disabledOutSource || loadingAnimation} // PDF生成中はボタンを無効化
              onClick={createPdf}
              label={loadingAnimation ? '処理中' : '外注納品書'} // ローディング中はテキスト変更
              icon={
                loadingAnimation ? (
                  <CircularProgress size={16} color="inherit" /> // スピナーを表示
                ) : (
                  <PictureAsPdfIcon />
                )
              }
              width={120}
              height={36}
              fontSize={16}
              backgroundColor="#84BBD2"
            />
          </div>
          <div>
            <WithIconButton
              disabled={disabledWorkDetail || loadingAnimation} // PDF生成中はボタンを無効化
              onClick={downloadCsv}
              width={120}
              height={36}
              fontSize={16}
              icon={
                loadingAnimation ? (
                  <CircularProgress size={16} color="inherit" /> // スピナーを表示
                ) : (
                  <SystemUpdateAltIcon />
                )
              }
              label={loadingAnimation ? '処理中' : '作業明細書'}
            />
          </div>
        </div>
        {pdfUrl && (
          <>
            <div className={classes.downLoad}>
              <a
                href={pdfUrl}
                download={
                  filterOption === 'single'
                    ? `外注納品書_${
                        workerInfo.workerName
                      }_${productNo}-${productBno}_${formatMonth(fromDate)}.pdf`
                    : `外注納品書_${workerInfo.workerName}_${formatMonth(
                        fromDate
                      )}.pdf`
                }
              >
                外注納品書ダウンロード
              </a>
            </div>
            <div className={classes.preview}>
              <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                {'外注納品書プレビュー'}
              </a>
            </div>
          </> // PDF URLが存在する場合にのみ表示
        )}
        {/* {pdfUrl &&isShowMailDialog && (

        )} */}

        {isShowMailDialog && workerInfo.workerName && pdfData && pdfUrl && (
          <MailDialog
            pdfName={
              filterOption === 'single'
                ? `外注納品書_${
                    workerInfo.workerName
                  }_${productNo}-${productBno}_${formatMonth(fromDate)}.pdf`
                : `外注納品書_${workerInfo.workerName}_${formatMonth(
                    fromDate
                  )}.pdf`
            }
            pdfData={pdfData!} // バイナリデータを渡す
            pdfUrl={pdfUrl!} // 表示用 URL
            factoryId={factoryId}
            wokerId={workerInfo.workerId}
            workerName={workerInfo.workerName}
            open={isShowMailDialog}
            setOpen={setShowMailDialog}
            toEmail={toEmail}
            ccEmail={ccEmail}
          />
        )}
        <div className={classes.toastContainer}>
          <ToastContainer
            containerId="MailForm"
            position="top-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </div>
    </Modal>
  )
}

export default OutSourcingDialog
